module.exports = __webpack_public_path__ + "images/sam/layout_sprite.png";